import { useCallback, useEffect, useRef, useState, } from 'react';
const MOBILE_NAVIGATION_BREAKPOINT = 992;
export const useBackdropMenu = () => {
    const [backdropOpen, setBackdropOpen] = useState(false);
    const [touched, setTouched] = useState(false);
    const openBtnRef = useRef(null);
    const closeBtnRef = useRef(null);
    const closeBackdrop = useCallback(() => {
        setBackdropOpen(false);
    }, []);
    const openBackdrop = useCallback(() => {
        setTouched(true);
        setBackdropOpen(true);
    }, []);
    const handleOnKeyDown = (e) => {
        if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            if (backdropOpen) {
                closeBackdrop();
            }
            else {
                openBackdrop();
            }
        }
    };
    const handleOnEscapeKeyDown = useCallback((e) => {
        if (e.key === 'Escape') {
            closeBackdrop();
        }
    }, [closeBackdrop]);
    const handleResize = useCallback(() => {
        if (window.innerWidth > MOBILE_NAVIGATION_BREAKPOINT) {
            closeBackdrop();
        }
    }, [closeBackdrop]);
    useEffect(() => {
        if (backdropOpen) {
            document.body.classList.add('suppress-scroll');
            window.addEventListener('keydown', handleOnEscapeKeyDown, true);
            window.addEventListener('resize', handleResize, false);
        }
        else {
            document.body.classList.remove('suppress-scroll');
            window.removeEventListener('keydown', handleOnEscapeKeyDown, true);
            window.removeEventListener('resize', handleResize, false);
        }
    }, [backdropOpen, handleOnEscapeKeyDown, handleResize]);
    useEffect(() => {
        var _a, _b;
        if (touched && !backdropOpen) {
            (_a = openBtnRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
        else {
            (_b = closeBtnRef.current) === null || _b === void 0 ? void 0 : _b.focus();
        }
    }, [backdropOpen, touched]);
    return {
        backdropOpen,
        closeBtnRef,
        openBtnRef,
        closeBackdrop,
        openBackdrop,
        handleOnKeyDown,
    };
};
//# sourceMappingURL=useBackdropMenu.js.map